function createIframe(videoUrl) {
	let iframe = document.createElement('iframe');

	iframe.setAttribute('allowfullscreen', '');
	iframe.setAttribute('allow', 'autoplay');
	iframe.setAttribute('src', videoUrl + '?rel=0&showinfo=0&autoplay=1');
	iframe.classList.add('js-video-iframe');

	return iframe;
}

function setupVideo(video) {
	let videoUrl = video.getAttribute('data-video-url');
	let media = video.querySelector('.js-video-media');

	video.addEventListener('click', () => {
		let existingIframe = video.querySelectorAll('.js-video-iframe');
		existingIframe.forEach((iframe) => {
			iframe.remove();
		});

		let iframe = createIframe(videoUrl);

		if (media) {
			media.classList.add('hidden');
		}

		video.appendChild(iframe);
	});

	video.classList.add('video--enabled');
}

function findVideos() {
	let videos = document.querySelectorAll('.js-academy-video-box');

	for (let i = 0; i < videos.length; i++) {
		setupVideo(videos[i]);
	}
}

export default findVideos;
